// @flow
import * as React from 'react';
import Editor from 'react-simple-wysiwyg';

type Props = {
  value: string,
  onChange: (value: string) => void,
  height?: number,
};
export const RichEditorField = ({value, height = 200, onChange}: Props) => {
  return (
    <Editor value={value} onChange={e => onChange(e.target.value)} />
  );
};

